'use client';
import React, { useRef, useEffect, useState } from 'react';

const whyChooseItems = [
  {
    icon: '⏣',
    title: '10+ Years Experience',
    description: 'Over a decade of dedicated practice in spiritual healing, energy work, and holistic wellness transformation.',
  },
  {
    icon: '💖',
    title: '1000+ Lives Impacted',
    description: 'Thousands of clients across India and globally have experienced profound healing and life transformation.',
  },
  {
    icon: '🔬',
    title: 'Scientific + Spiritual Approach',
    description: 'A unique blend of evidence-based techniques and ancient spiritual wisdom for complete healing.',
  },
  {
    icon: '🌟',
    title: 'Personalized Healing',
    description: 'Every session is uniquely tailored to your individual needs, energy, and healing journey.',
  },
  {
    icon: '🔒',
    title: 'Confidential Sessions',
    description: 'Complete privacy and confidentiality maintained in every session. Your healing journey is sacred.',
  },
];

export default function StatsSection() {
  const [visible, setVisible] = useState(false);
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => { if (entry.isIntersecting) setVisible(true); },
      { threshold: 0.1 }
    );
    if (ref?.current) observer?.observe(ref?.current);
    return () => observer?.disconnect();
  }, []);

  return (
    <section
      id="why-choose"
      className="relative py-20 overflow-hidden"
      style={{
        background: 'linear-gradient(135deg, #130a24 0%, #1a0d30 50%, #130a24 100%)',
        borderTop: '1px solid rgba(201,168,76,0.18)',
        borderBottom: '1px solid rgba(201,168,76,0.18)',
      }}
    >
      <div
        className="absolute inset-0 opacity-40 pointer-events-none"
        style={{ background: 'linear-gradient(90deg, transparent 0%, rgba(201,168,76,0.06) 50%, transparent 100%)' }}
      />

      <div className="max-w-7xl mx-auto px-6 relative z-10">
        {/* Header */}
        <div className="text-center mb-14">
          <div className="flex items-center justify-center gap-4 mb-4">
            <div className="h-px w-12 bg-gradient-to-r from-transparent to-[#c9a84c]/60" />
            <span className="text-[#c9a84c] text-xs tracking-[0.4em] uppercase font-medium">Why Choose Us</span>
            <div className="h-px w-12 bg-gradient-to-l from-transparent to-[#c9a84c]/60" />
          </div>
          <h2
            className="font-serif text-4xl md:text-5xl font-bold mb-4"
            style={{
              background: 'linear-gradient(135deg, #c4b5fd 0%, #9b7fe8 50%, #c9a84c 100%)',
              WebkitBackgroundClip: 'text',
              WebkitTextFillColor: 'transparent',
              backgroundClip: 'text',
            }}
          >
            Why Choose Shreevidha Healing Hub
          </h2>
          <div className="section-divider" />
        </div>

        <div
          ref={ref}
          className={`grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-6 transition-all duration-1000 ${visible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'}`}
        >
          {whyChooseItems?.map((item, index) => (
            <div
              key={item?.title}
              className="text-center p-6 rounded-2xl"
              style={{
                background: 'rgba(22, 12, 40, 0.70)',
                border: '1px solid rgba(201,168,76,0.18)',
                opacity: visible ? 1 : 0,
                transform: visible ? 'translateY(0)' : 'translateY(20px)',
                transition: `opacity 0.7s ease ${index * 100}ms, transform 0.7s ease ${index * 100}ms`,
              }}
            >
              <div className="text-3xl mb-3">{item?.icon}</div>
              <div
                className="font-serif text-base font-semibold mb-2"
                style={{
                  background: 'linear-gradient(135deg, #c9a84c 0%, #e8c96a 50%, #c9a84c 100%)',
                  WebkitBackgroundClip: 'text',
                  WebkitTextFillColor: 'transparent',
                  backgroundClip: 'text',
                }}
              >
                {item?.title}
              </div>
              <div className="text-[#c4b5fd]/55 text-xs leading-relaxed">
                {item?.description}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
